import { laneRoadClasses } from "./laneRoadClass.mjs";

// Annotates every LM lane with `laneRoadClass`, the highway class of the road area
// it belongs to (see laneRoadClass.mjs), for the lane road-class view.
//
// Recomputed on every featuresloadend because a lane and the relations that lead to
// its area can arrive in separate bbox loads. Only sets a property (no addFeature),
// so it doesn't re-fire featuresloadend; OL's set() is a no-op for an unchanged
// value, so lanes that already had their class don't re-render.
export const laneRoadClassHandler = (event) => {
  const features = event.target.getFeatures();
  const classById = laneRoadClasses(features);
  features.forEach((feature) => {
    if (feature.get("type") === "ORBIS_RELATION") {
      return;
    }
    const roadClass = classById.get(feature.getId());
    if (roadClass !== undefined) {
      feature.set("laneRoadClass", roadClass);
    }
  });
};
